import React, { useState, useEffect } from "react";
import { FaChartLine, FaUser, FaUsers } from "react-icons/fa6";
import { RiMoneyDollarCircleFill, RiPagesLine } from "react-icons/ri";
import dynamic from "next/dynamic";
import DashboardCarousel from "./DashboardCarousel";
import useProfile from "../../../hooks/queryHooks/getUser";
import { useActiveAccount } from "thirdweb/react";
import { useDispatch } from 'react-redux';
import { toggleModal } from '../../../redux/reservedDomainsSlice';
import DomainStatsCard from "./DomainStatsCard";
import NFTStatsCard from "./NFTStatsCard";
import RevenueCard from "./RevenueCard";
import NotificationsCard from "./NotificationsCard";
import {
  MdDomain,
  MdNotificationsActive,
  MdNotificationsNone,
  MdOutlinePayments,
  MdOutlinePermIdentity,
} from "react-icons/md";
import { SiKashflow } from "react-icons/si";

import Link from "next/link";
import { BsCash } from "react-icons/bs";
import { InfoAlert, YellowAlert } from "../../alerts";
import { useLocalStorage } from '../../../hooks/useLocalStorage';
import useAnalytics from "../../../hooks/queryHooks/getAnalytics";
import Loading from "../../Loading";
import CSVDownloadButton from "../../common/CSVDownloadButton";
import { formatDate } from "../../../lib/util";
import { useRouter } from 'next/router';
const Chart = dynamic(() => import("react-apexcharts"), { ssr: false });




const notifications = [
  {
    type: "alert",
    icon: "🔔",
    title: "AI Credits Low",
    message: "Your AI credits are running low. Consider refilling soon.",
    time: "2 hours ago",
  },
  {
    type: "success",
    icon: "💰",
    title: "Payment Available",
    message: "You have $123.45 available to claim",
    time: "5 hours ago",
  },
  {
    type: "info",
    icon: "📝",
    title: "Mint Status",
    message: "NFT minting was unsuccessful",
    time: "1 day ago",
  },
];

export default function DashboardMain() {
  const dispatch = useDispatch();
  const router = useRouter();
  const userAddress = useActiveAccount();
  const address = userAddress?.address;
  const { data: user } = useProfile(address);
  const { data: analytics,isLoading } = useAnalytics(address);
  

  // const [hasSeenModal, setHasSeenModal, removeHasSeenModal] = useLocalStorage('reservedModalShown', false);

  // useEffect(() => {
  //   // Check if user hasn't bought free domainz and hasn't seen the modal
  //   if (!user?.freeDomainzBought && !hasSeenModal) {
  //   console.log("user", user);
  //     dispatch(toggleModal(true));
  //     setHasSeenModal(true);
  //   }
  // }, [user, hasSeenModal, setHasSeenModal, dispatch]);

  // Optional: Function to reset modal (for testing)
  // const resetModal = () => {
  //   removeHasSeenModal();
  //   dispatch(toggleModal(false));
  // };

  // const Alert = !user?.freeDomainzBought ? YellowAlert : InfoAlert


const domainPurchaseUsers = analytics?.domainPurchaseUsers.map((user) => ({
  ...user,
  email: user.user.email,
  createdAt: formatDate(user.createdAt)
}))

// Open modal automatically if URL contains startforfree=true
useEffect(() => {
  if (router.query.startforfree === 'true') {
    dispatch(toggleModal(true));
  }
}, [router.query, dispatch]);

if(isLoading) return  <div className='relative h-[50vh] w-full flex justify-center items-center'><Loading /></div>

  return (
    <div className="dark:bg-jacarta-900 p-4 md:p-8">
      {/* Yellow alert section */}
      <YellowAlert 
        message={`Get started with a FREE username.domainz web3 Name`} 
        btn={
          <button 
            className={` bg-amber-700 hover:bg-amber-800 text-white text-sm md:text-base px-2 md:px-4 py-2 rounded-md transition-colors min-w-28 `} 
            onClick={() => dispatch(toggleModal(true))}
          >
          Start Now
          </button>
        } 
      />
      
      {/* First row - Domain and User stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-10">
        <div className="dark:bg-jacarta-800 bg-white rounded-2xl p-6 shadow-sm w-full h-96 relative">
          <h2 className="text-lg font-display mb-6 flex items-center gap-2">
            <MdDomain className="w-6 h-6" />
            Domains
          </h2>
          <DomainStatsCard
            totalDomains={analytics?.domainsCount || 0}
            tlds={analytics?.tldCount || 0}
            slds={analytics?.sldCount || 0}
            reservedCount={analytics?.reservedCount || 0}
          />
          <div className="absolute right-6 -bottom-2 transform -mr-6 opacity-10">
            <RiPagesLine className="text-accent text-[150px]" />
          </div>
        </div>
        
       
        <div className="dark:bg-jacarta-800 bg-white rounded-2xl p-5 shadow-sm w-full h-96 relative">
          <div className="flex justify-between items-center">
          <h2 className="text-lg font-display mb-4 flex items-center gap-2">
    <SiKashflow className="w-5 h-5" />
    Domain Purchases
  </h2>
            <CSVDownloadButton
            data={domainPurchaseUsers}
            fields={['email', 'sldDomain', 'amount', 'createdAt']}
            headers={['User', 'Domain', 'Price', 'Date']}
            filename="domain_purchases.csv"
            isLoading={isLoading}
          />
          </div>

  {analytics?.domainPurchaseUsers && analytics.domainPurchaseUsers.length > 0 ? (
    <div className="max-h-[290px] overflow-auto thin-scrollbar pr-1">
      <table className="w-full text-sm">
        <thead className="border-b border-jacarta-100 dark:border-jacarta-600">
          <tr>
            <th className="text-left py-2 font-medium text-jacarta-700 dark:text-jacarta-300">User</th>
            <th className="text-left py-2 font-medium text-jacarta-700 dark:text-jacarta-300">Domain</th>
            <th className="text-right py-2 font-medium text-jacarta-700 dark:text-jacarta-300">Price</th>
            <th className="text-right py-2 font-medium text-jacarta-700 dark:text-jacarta-300">Date</th>
          </tr>
        </thead>
        <tbody>
          {analytics.domainPurchaseUsers.map((purchase, index) => (
            <tr key={index} className="border-b border-jacarta-100 dark:border-jacarta-600 hover:bg-jacarta-50 dark:hover:bg-jacarta-700">
              <td className="py-3">
                <div className="text-xs text-jacarta-500 dark:text-jacarta-500 truncate max-w-[110px] md:max-w-[150px]" title={purchase.user.email || "No email"}>
                  {purchase.user.email || "No email"}
                </div>
              </td>
              <td className="py-3">
                <div className="font-medium text-jacarta-900 dark:text-white">{purchase.sldDomain}</div>
            
              </td>
              <td className="py-3 text-right text-accent font-medium">${purchase.amount}</td>
              <td className="py-3 text-right">
                <span className={`px-2 py-1 rounded-full text-xs`}>
                       {new Date(purchase.createdAt).toLocaleDateString(undefined, {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </span>
              </td>
            </tr>
          ))}
          
        </tbody>
      </table>
    </div>
  ) : (
    <div className="flex items-center justify-center h-[290px] text-jacarta-500 dark:text-jacarta-300">
      No domain purchases found
    </div>
  )}
  <div className="absolute right-6 bottom-1 transform -mr-6 opacity-10">
    <MdDomain className="text-accent text-[120px]" />
  </div>
</div>
      </div>
      
      {/* Second row - Domain Purchases, Payouts, Notifications */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 my-10">
        {/* Domain Purchase Users Section */}
        <div className="dark:bg-jacarta-800 bg-white rounded-2xl p-6 shadow-sm w-full h-96 relative">
          <h2 className="text-lg font-display mb-6 flex items-center gap-2">
            <MdOutlinePermIdentity className="w-6 h-6" />
            Users
          </h2>
          {analytics?.userGrowth && analytics.userGrowth.length > 0 && (
            <div className="flex flex-col gap-4">
              <div className="flex justify-between items-center">
                <span className="text-sm text-jacarta-700 dark:text-jacarta-300">Total Users:</span>
                <span className="font-bold text-lg">{analytics.userGrowth[0].totalUsers}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-jacarta-700 dark:text-jacarta-300">Total Purchases:</span>
                <span className="font-bold text-lg">{analytics.userGrowth[0].totalPurchases}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-jacarta-700 dark:text-jacarta-300">Total Amount:</span>
                <span className="font-bold text-lg">${analytics.userGrowth[0].totalAmount}</span>
              </div>
            </div>
          )}
          <div className="absolute right-8 -bottom-0 transform -mr-6 opacity-10">
            <FaUsers className="text-accent text-[150px]" />
          </div>
        </div>

        {/* Compact Payouts Section */}
        <div className="dark:bg-jacarta-800 bg-white rounded-2xl p-5 shadow-sm w-full h-96 relative">
          <h2 className="text-lg font-display mb-4 flex items-center gap-2">
            <MdOutlinePayments className="w-5 h-5" />
            Payouts
          </h2>
          {analytics?.payouts && (
            <div className="flex flex-col">
              {/* Summary boxes */}
              <div className="grid grid-cols-2 gap-2 mb-3">
                <div className="bg-jacarta-50 dark:bg-jacarta-700 p-2 rounded">
                  <div className="text-xs text-jacarta-700 dark:text-jacarta-300">Remaining:</div>
                  <div className="font-bold text-base">${analytics.remainingPayoutAmount || 0}</div>
                </div>
                <div className="bg-jacarta-50 dark:bg-jacarta-700 p-2 rounded">
                  <div className="text-xs text-jacarta-700 dark:text-jacarta-300">Completed:</div>
                  <div className="font-bold text-base">${analytics.completedPayoutAmount || 0}</div>
                </div>
              </div>
              
              {/* Pending payouts heading */}
              <h3 className="font-medium text-sm mb-2 text-jacarta-700 dark:text-white">Pending Payouts</h3>
              
              {/* Pending payouts list */}
              <div className="max-h-[180px] overflow-auto thin-scrollbar pr-1">
                <table className="w-full text-sm">
                  <tbody>
                    {analytics.payouts.map((payout, index) => (
                      <tr key={index} className="border-b border-jacarta-100 dark:border-jacarta-600 hover:bg-jacarta-50 dark:hover:bg-jacarta-700">
                        <td className="py-2 text-accent font-medium">${payout.amount}</td>
                        <td className="py-2 text-right text-xs text-jacarta-500 dark:text-jacarta-300">
                          {formatDate(payout.clearingDate)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div className="absolute right-6 bottom-1 transform -mr-6 opacity-10">
            <BsCash className="text-accent text-[120px]" />
          </div>
        </div>

        {/* Notifications Section */}
        <div className="dark:bg-jacarta-800 bg-white rounded-2xl p-6 shadow-sm w-full h-96 relative">
          <div className="mb-6 flex items-center justify-between">
            <h2 className="text-lg font-display flex items-center gap-2">
              <MdNotificationsNone className="w-6 h-6" />
              Notifications
            </h2>
            <Link
              href="/dashboard/notifications"
              className="text-jacarta-800 dark:text-accent"
            >
              View All →
            </Link>
          </div>
          <NotificationsCard notifications={notifications} />
          <div className="absolute right-6 -bottom-0 transform -mr-6 opacity-10">
            <MdNotificationsActive className="text-accent text-[150px]" />
          </div>
        </div>
      </div>
      
      {/* Growth Analytics Chart - Bar Chart with Month Padding */}
      <div className="grid grid-cols-1 my-10">
        <div className="dark:bg-jacarta-800 bg-white rounded-2xl p-6 shadow-sm relative overflow-hidden">
          <h2 className="text-lg font-display mb-6">Growth Analytics</h2>
          <Chart
            options={{
              chart: {
                type: 'bar',
                background: 'transparent',
                toolbar: {
                  show: false,
                },
                fontFamily: 'DM Sans, sans-serif',
              },
              // Beautiful color scheme based on #02f6d1
              colors: ["#02f6d1", "#02c6ab", "#029f8a"],
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '55%',
                  endingShape: 'rounded',
                  borderRadius: 6,
                },
              },
              dataLabels: {
                enabled: false,
              },
              fill: {
                opacity: 1,
                type: 'solid',
              },
              grid: {
                borderColor: 'rgba(110, 113, 141, 0.1)',
                strokeDashArray: 3,
                xaxis: {
                  lines: {
                    show: false,
                  },
                },
              },
              xaxis: {
                // Logic to pad timeline with extra month before/after when limited data
                categories: (() => {
                  if (analytics?.userGrowth && analytics.userGrowth.length > 0) {
                    // If we have real data
                    const months = analytics.userGrowth.map(item => item.month);
                    
                    // For single month data, add month before and after
                    if (months.length === 1) {
                      const monthMap = {
                        'Jan': ['Dec', 'Feb'],
                        'Feb': ['Jan', 'Mar'],
                        'Mar': ['Feb', 'Apr'],
                        'Apr': ['Mar', 'May'],
                        'May': ['Apr', 'Jun'],
                        'Jun': ['May', 'Jul'],
                        'Jul': ['Jun', 'Aug'],
                        'Aug': ['Jul', 'Sep'],
                        'Sep': ['Aug', 'Oct'],
                        'Oct': ['Sep', 'Nov'],
                        'Nov': ['Oct', 'Dec'],
                        'Dec': ['Nov', 'Jan']
                      };
                      
                      // Handle both short month names and longer formats like "Mar-2025"
                      const mainMonth = months[0];
                      let monthPart = mainMonth.split('-')[0];
                      let yearPart = mainMonth.includes('-') ? `-${mainMonth.split('-')[1]}` : '';
                      
                      if (monthMap[monthPart]) {
                        return [
                          monthMap[monthPart][0] + yearPart, 
                          mainMonth, 
                          monthMap[monthPart][1] + yearPart
                        ];
                      }
                      
                      // Fallback: just return what we have plus generic padding
                      return ['Previous', mainMonth, 'Next'];
                    }
                    
                    return months;
                  }
                  
                  // Default if no data
                  return ["Jan", "Feb", "Mar"];
                })(),
                labels: {
                  style: {
                    colors: "#6E718D",
                    fontSize: "12px",
                  },
                },
                axisBorder: {
                  show: false,
                },
                axisTicks: {
                  show: false,
                },
              },
              yaxis: {
                labels: {
                  style: {
                    colors: "#6E718D",
                    fontSize: "12px",
                  },
                  formatter: (value) => Math.round(value),
                },
              },
              tooltip: {
                theme: "dark",
                shared: true,
                intersect: false,
                style: {
                  fontSize: '14px',
                },
                y: {
                  formatter: (value, { seriesIndex, dataPointIndex, w }) => {
                    // Don't show numeric values for padding months (will be 0)
                    const categories = w.config.xaxis.categories;
                    const originalDataLen = analytics?.userGrowth?.length || 0;
                    
                    // If single month with padding
                    if (originalDataLen === 1 && categories.length === 3 && dataPointIndex !== 1) {
                      return "No data";
                    }
                    
                    const seriesName = w.config.series[seriesIndex].name;
                    if (seriesName === "Total Amount ($)") {
                      return "$" + value;
                    }
                    return value + (seriesName === "Total Users" ? " users" : " purchases");
                  }
                }
              },
              legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                offsetY: 7,
                itemMargin: {
                  horizontal: 12,
                  vertical: 0
                },
                fontSize: '13px',
                labels: {
                  colors: "#6E718D",
                },
                markers: {
                  width: 10,
                  height: 10,
                  strokeWidth: 0,
                  radius: 10,
                  offsetX: -3,
                },
              },
              states: {
                hover: {
                  filter: {
                    type: 'lighten',
                    value: 0.05
                  }
                },
                active: {
                  filter: {
                    type: 'darken',
                    value: 0.1
                  }
                }
              }
            }}
            series={[
              {
                name: "Total Users",
                data: (() => {
                  if (analytics?.userGrowth && analytics.userGrowth.length > 0) {
                    const data = analytics.userGrowth.map(item => item.totalUsers);
                    
                    // For single month data, add zeros before and after
                    if (data.length === 1) {
                      return [0, data[0], 0];
                    }
                    
                    return data;
                  }
                  return [0, 0, 1];
                })()
              },
              {
                name: "Total Purchases",
                data: (() => {
                  if (analytics?.userGrowth && analytics.userGrowth.length > 0) {
                    const data = analytics.userGrowth.map(item => item.totalPurchases);
                    
                    // For single month data, add zeros before and after
                    if (data.length === 1) {
                      return [0, data[0], 0];
                    }
                    
                    return data;
                  }
                  return [0, 0, 3];
                })()
              },
              {
                name: "Total Amount ($)",
                data: (() => {
                  if (analytics?.userGrowth && analytics.userGrowth.length > 0) {
                    const data = analytics.userGrowth.map(item => item.totalAmount);
                    
                    // For single month data, add zeros before and after
                    if (data.length === 1) {
                      return [0, data[0], 0];
                    }
                    
                    return data;
                  }
                  return [0, 0, 30];
                })()
              }
            ]}
            type="bar"
            height={320}
          />
        </div>
      </div>
    </div>
  );
}
